import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import OrgTree from '../components/OrgTree'
import OrgDetail from '../components/OrgDetail'
import OrgCreate from '../components/OrgCreate'
import MenuGuideButton from '../components/MenuGuideButton'

export default function OrgsPage() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [orgQ, setOrgQ] = useState('')
    const [selected, setSelected] = useState(null)
    const [refreshKey, setRefreshKey] = useState(0)

    /** 원수사 마스터 등에서 `/orgs?openOrg=123` 로 진입 시 해당 조직 선택·청구 로고 블록까지 바로 표시 */
    useEffect(() => {
        const raw = searchParams.get('openOrg') || searchParams.get('focusOrgId')
        if (!raw) return
        const id = Number(raw)
        if (!Number.isFinite(id) || id <= 0) return
        setSelected({ id })
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev)
            next.delete('openOrg')
            next.delete('focusOrgId')
            return next
        }, { replace: true })
    }, [searchParams, setSearchParams])

    const handleRefresh = () => {
        setRefreshKey(prev => prev + 1)
    }
    return (
        <section>
            <div className="flex flex-wrap items-center gap-2">
                <h1 className="text-2xl font-bold">조직 관리</h1>
                <MenuGuideButton slug="orgs" title="조직관리 가이드" />
            </div>
            
            <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* 조직 트리 */}
                <div className="rounded border p-4">
                    <h2 className="font-semibold mb-3">조직 트리</h2>
                    <div className="mb-3">
                        <input 
                            className="w-full rounded border px-3 py-2 text-sm" 
                            placeholder="검색: 조직명" 
                            value={orgQ} 
                            onChange={(e) => setOrgQ(e.target.value)} 
                        />
                    </div>
                    <OrgTree 
                        key={`tree-${refreshKey}`}
                        onSelect={setSelected}
                        selectedId={selected?.id}
                        searchQuery={orgQ}
                    />
                </div>

                {/* 조직 상세 및 관리 */}
                <div className="lg:col-span-2 space-y-6">
                    {/* 조직 상세 */}
                    <div className="rounded border p-4">
                        <h2 className="font-semibold mb-3">조직 상세</h2>
                        <OrgDetail 
                            selectedOrg={selected}
                            onUpdate={handleRefresh}
                            onDelete={() => {
                                setSelected(null)
                                handleRefresh()
                            }}
                        />
                    </div>

                    {/* 조직 생성: 선택된 조직 하위 생성도 항상 가능하도록 노출 */}
                    <div className="rounded border p-4">
                        <h2 className="font-semibold mb-3">{selected ? '하위 조직 생성' : '새 조직 생성'}</h2>
                        <OrgCreate
                            key={`create-${selected?.id || 'root'}-${refreshKey}`}
                            onCreate={handleRefresh}
                            defaultParentOrgId={selected?.id || null}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

